import { normalizeToCurrentTimezone } from "./timezoneDateFormat";

export function getTodayOpenHours(data: any, selectedDate: Date, formattedHolidays: any[]) {
  const today = selectedDate
    .toLocaleString("en-US", { weekday: "long" })
    .toLowerCase();

  const formattedSelectedDate = selectedDate.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const holiday = formattedHolidays.find((h) => {
    const holidayDate = new Date(h.date).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    return holidayDate === formattedSelectedDate;
  });

  if (holiday && holiday.time) {
    const [from, to] = holiday.time.split(" - ");
    const openFrom = new Date(`${holiday.date} ${from}`);
    const openTo = new Date(`${holiday.date} ${to}`);

    return {
      openFrom,
      openTo,
      isHoliday: true,
    };
  }

  const todaySchedule = data?.[today];
  if (todaySchedule && !todaySchedule.closedAllDay) {
    const [openH, openM, openS] = todaySchedule.openFrom.split(":").map(Number);
    const [closeH, closeM, closeS] = todaySchedule.openTo.split(":").map(Number);
    const baseDate = new Date(selectedDate);
    const openUTC = new Date(
      Date.UTC(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        baseDate.getDate(),
        openH,
        openM,
        openS || 0
      )
    );

    const closeDateOffset = closeH < openH ? 1 : 0;

    const closeUTC = new Date(
      Date.UTC(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        baseDate.getDate() + closeDateOffset,
        closeH,
        closeM,
        closeS || 0
      )
    );

    return {
      openFrom: normalizeToCurrentTimezone(openUTC),
      openTo: normalizeToCurrentTimezone(closeUTC),
      isHoliday: false,
    };
  }

  return null;
}
